import { isDefined } from "@clipboard-health/util-ts";
import { useHistory } from "react-router-dom";

import { PROFILE_FULL_PATH } from "../../Accounts/paths";
import { PageWrapper } from "../../components/PageWrapper";
import { WorkBadgeSelectHeadshot } from "../components/WorkBadgeSelectHeadshot";
import { WorkBadgesReady } from "../components/WorkBadgesReady";
import { ProfileWorkBadgesInfo } from "./components/ProfileWorkBadgesInfo";
import { ProfileWorkBadgesSelectRole } from "./components/ProfileWorkBadgesSelectRole";
import { ProfileWorkBadgesStep, useProfileWorkBadges } from "./hooks/useProfileWorkBadges";

export function WorkBadgesProfilePage() {
  const {
    step,
    setStep,
    isLoadingQualifications,
    activeQualifications,
    handleQualificationSelect,
    selectedQualificationId,
    selectedQualification,
    workerHeadshotBase64,
    setWorkerHeadshotBase64,
  } = useProfileWorkBadges();

  const history = useHistory();

  return (
    <PageWrapper variant="tertiary">
      {step === ProfileWorkBadgesStep.INFO && (
        <ProfileWorkBadgesInfo
          isLoading={isLoadingQualifications}
          onGetStarted={() => {
            setStep(ProfileWorkBadgesStep.SELECT_ROLE);
          }}
        />
      )}

      {step === ProfileWorkBadgesStep.SELECT_ROLE && (
        <ProfileWorkBadgesSelectRole
          activeQualifications={activeQualifications}
          selectedQualificationId={selectedQualificationId}
          handleQualificationSelect={handleQualificationSelect}
          onContinue={() => {
            setStep(ProfileWorkBadgesStep.SELECT_HEADSHOT);
          }}
          onBack={() => {
            setStep(ProfileWorkBadgesStep.INFO);
          }}
        />
      )}

      {step === ProfileWorkBadgesStep.SELECT_HEADSHOT && isDefined(selectedQualification) && (
        <WorkBadgeSelectHeadshot
          qualificationName={selectedQualification.qualification.attributes.displayLabel}
          onConfirm={(newWorkerHeadshotBase64) => {
            setWorkerHeadshotBase64(newWorkerHeadshotBase64);
            setStep(ProfileWorkBadgesStep.BADGE_READY);
          }}
          onBack={() => {
            setStep(ProfileWorkBadgesStep.SELECT_ROLE);
          }}
        />
      )}

      {step === ProfileWorkBadgesStep.BADGE_READY &&
        isDefined(selectedQualification) &&
        isDefined(workerHeadshotBase64) && (
          <WorkBadgesReady
            qualificationName={selectedQualification.qualification.attributes.displayLabel}
            emailSuccessModal={{
              primaryButtonText: "Go back to Profile",
              onPrimaryButtonClick: () => {
                history.push(PROFILE_FULL_PATH);
              },
            }}
            workerHeadshotBase64={workerHeadshotBase64}
            onBack={() => {
              setStep(ProfileWorkBadgesStep.SELECT_HEADSHOT);
            }}
          />
        )}
    </PageWrapper>
  );
}
